import React from "react";
import PropTypes from "prop-types";
import { NewsFeed as NewsFeedComponents } from "@sunwing/shared-components";
import { Modal } from "../Modal";
import { Heading, HeadingAsElement, HeadingSize, HeadingAlign } from "../Heading";
import styles from "./NewsFeed.module.scss";

const NewsFeed = ({ lang, cols, items, dateFormat, heading, as, size, align, renderImage }) => (
	<NewsFeedComponents
		classNames={styles}
		lang={lang}
		cols={cols}
		items={items}
		dateFormat={dateFormat}
		closeButtonIcon={false}
		heading={heading}
		TitleComponent={Heading}
		titleComponentProps={{
			as,
			size,
			align,
		}}
		ModalComponent={Modal}
		renderImage={renderImage}
	/>
);

NewsFeed.propTypes = {
	lang: PropTypes.oneOf(["en", "fr"]),
	cols: PropTypes.oneOf([1, 2, 3, 4]),
	heading: PropTypes.string,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			featuredImage: PropTypes.shape({
				alt: PropTypes.string.isRequired,
				src: PropTypes.string.isRequired,
			}),
			postDate: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			content: PropTypes.node.isRequired,
		}).isRequired
	).isRequired,
	dateFormat: PropTypes.string,
	as: PropTypes.oneOf(Object.keys(HeadingAsElement)),
	size: PropTypes.oneOf(Object.keys(HeadingSize)),
	align: PropTypes.oneOf(Object.keys(HeadingAlign)),
	renderImage: PropTypes.func,
};

NewsFeed.defaultProps = {
	lang: "en",
	heading: undefined,
	dateFormat: "ddd MMMM D, YYYY",
	cols: 3,
	as: HeadingAsElement.h2,
	size: HeadingSize.h1,
	align: HeadingAlign.center,
	renderImage: undefined,
};

export default NewsFeed;
export { NewsFeed };
